import {useState} from 'react'
import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'

/**
 * SOS — a red disc on the full-screen tracking map, beside the close control.
 *
 * ⚠️ A "COMING SOON" NOTICE, NOT AN ALERT. There is no SOS endpoint on the passenger API
 * (only an `sos` block in the support config), so pressing this tells nobody anything. The
 * modal says so plainly — the mobile app's own copy — rather than looking like help is on
 * the way. Wire it to a real endpoint when the backend has one.
 */
export default function SosButton({className = ''}) {
    const [open, setOpen] = useState(false)

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                aria-label="SOS emergency"
                className={`flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border-0 bg-(--text-red) p-0 text-xs font-bold text-white shadow-[0_2px_10px_rgba(0,0,0,0.25)] ${className}`}
            >
                SOS
            </button>

            <Modal isOpen={open} onClose={() => setOpen(false)} className="max-w-md!">
                <div className="flex flex-col items-center text-center">
                    <div className="relative mb-6 flex h-28 w-28 items-center justify-center rounded-full bg-[#FDE2E2] max-md:h-24 max-md:w-24">
                        <svg className="h-14 w-14 max-md:h-12 max-md:w-12" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3z" fill="#EF4444"/>
                            <path d="m8.5 12 2.5 2.5 4.5-5" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span className="absolute -bottom-3 rounded-full bg-[#FBBF24] px-3 py-0.5 text-xs font-bold tracking-wide text-(--text-primary)">
                            SOON
                        </span>
                    </div>

                    <h3 className="mb-3! text-2xl font-bold max-md:text-xl">SOS Emergency</h3>
                    <p className="mb-6! text-(--text-secondary) max-md:text-sm">
                        Your safety is our top priority. We are currently building a direct line to
                        emergency services and 24/7 support right from the app.
                    </p>

                    <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="w-full cursor-pointer rounded-full border-0 bg-(--text-primary) py-4 font-bold text-white max-md:py-3"
                    >
                        Got it
                    </button>
                </div>
            </Modal>
        </>
    )
}

export {SosButton}
